import { Component, OnInit,Input } from '@angular/core';

@Component({
  selector: 'mensagem-validacao',
  templateUrl: './mensagem-validacao.component.html',
  styleUrls: ['./mensagem-validacao.component.scss']
})
export class MensagemValidacaoComponent implements OnInit {

  @Input() mensagem: String;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/mensagem-validacao/mensagem-validacao.component.ts